import React from "react";

const FitViewRect = ({ width, height, style, className, color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    className={className}
    viewBox="0 0 24 24"
  >
    <polyline
      points="22 6 22 2 18 2"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
    />
    <polyline
      points="2 18 2 22 6 22"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
    />
    <polyline
      points="18 22 22 22 22 18"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
    />
    <polyline
      points="6 2 2 2 2 6"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);
export default FitViewRect;
